import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-xhr-backend';

import { getPartner } from '../../constants';
import { getUrlParams } from '../../helpers/helpers';
import b2b_en_HK from '../../assets/i18n/b2b/en-HK.json';
import b2b_vi_VN from '../../assets/i18n/b2b/vi-VN.json';
import b2b_zh_Hant_HK from '../../assets/i18n/b2b/zh-Hant-HK.json';
const resources = {
  'b2b_en-HK': { translation: b2b_en_HK },
  'b2b_zh-Hant-HK': { translation: b2b_zh_Hant_HK },
  'b2b_vi-VN': { translation: b2b_vi_VN },
};

export const defaultLang = (): string | undefined => {
  const PARTNER = getUrlParams().get('partner') || getPartner();
  for (const key in resources) {
    const [partner] = key.split('_');
    if (PARTNER) {
      if (PARTNER === partner) {
        return key;
      }
    }
  }
  return 'b2b_en-HK';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(backend)
  .init({
    resources,
    keySeparator: '.',
    fallbackLng: defaultLang(),
    load: 'currentOnly',
    react: {
      wait: true,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      // order and from where user language should be detected
      order: ['localStorage'],

      // keys or params to lookup language from
      lookupQuerystring: 'lang',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,

    },
  });
export default i18n;